module.exports = __webpack_public_path__ + "static/media/thepcspartners.04162505.png";